import dayjs from "dayjs";

interface DetailData {
  liked?: boolean;
  likes_count?: number;
  title?: string;
  author: {
    avatar_url?: string;
    name?: string;
  };
  copyright?: string;
  publishTime?: string;
  description?: string;
  content?: string;
  seo: {
    des?: string;
    keywords?: string[];
    title?: string;
  };
  publishedAt?: string;
  published_at?: string;
}

// 计算时间差，并换算为对应格式
const timeDiff = (publish: string) => {
  const difference = Date.now() - Date.parse(publish);
  const seconds = difference / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  const days = hours / 24;
  const now = new Date(publish);
  const timeYear = now.getFullYear();
  const timeMonth = now.getMonth() + 1;
  const timeDay = now.getDate();
  const timeStr =
    seconds < 60
      ? "刚刚"
      : minutes < 60
      ? `${Math.floor(minutes)}分钟前`
      : hours < 24
      ? `${Math.floor(hours)}小时前`
      : days < 7
      ? `${Math.floor(days)}天前`
      : timeYear === new Date().getFullYear()
      ? `${timeMonth}月${timeDay}日`
      : `${timeYear}年${timeMonth}月${timeDay}日`;
  return timeStr;
};

// 判断是否是今天
const isToday = (publish: string) => {
  const publishDate = publish.toString().slice(0, 10);
  const today = dayjs(Date.now())
    .format("YYYY/MM/DD")
    .toString();
  return publishDate === today ? "今天" : dayjs(publish).format("MM月DD日");
};

const formatList = (initData: DetailData[]) =>
  initData.map((item: { publishedAt?: string; published_at?: string }) => ({
    ...item,
    publishTime: isToday(item.publishedAt || item.published_at),
  }));

const formatDetail = (initData: DetailData) => {
  return {
    ...initData,
    publishTime: timeDiff(initData.published_at || initData.publishedAt),
  };
};

export { DetailData, formatList, formatDetail };
